import { render } from "./Nekhl central Hospital.vue?vue&type=template&id=ad65a560&scoped=true"
const script = {}

import "./Nekhl central Hospital.vue?vue&type=style&index=0&id=ad65a560&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ad65a560"

export default script